/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_Preference_Weekdays_InvalidInputs */

const en_us2_notification_preference_weekdays_invalid = /** @type {(inputs: Notification_Preference_Weekdays_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick at least one day for the reminder, each day once.`)
};

const pt_br2_notification_preference_weekdays_invalid = /** @type {(inputs: Notification_Preference_Weekdays_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha pelo menos um dia para o lembrete, cada dia uma vez só.`)
};

const es_419_notification_preference_weekdays_invalid = /** @type {(inputs: Notification_Preference_Weekdays_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige al menos un día para el recordatorio, cada día una sola vez.`)
};

const pt_pt2_notification_preference_weekdays_invalid = /** @type {(inputs: Notification_Preference_Weekdays_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe pelo menos um dia para o lembrete, cada dia uma só vez.`)
};

const fr_fr2_notification_preference_weekdays_invalid = /** @type {(inputs: Notification_Preference_Weekdays_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis au moins un jour pour le rappel, chaque jour une seule fois.`)
};

const de_de2_notification_preference_weekdays_invalid = /** @type {(inputs: Notification_Preference_Weekdays_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl mindestens einen Tag für die Erinnerung, jeden Tag nur einmal.`)
};

const it_it2_notification_preference_weekdays_invalid = /** @type {(inputs: Notification_Preference_Weekdays_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli almeno un giorno per il promemoria, ogni giorno una volta sola.`)
};

/**
* | output |
* | --- |
* | "Pick at least one day for the reminder, each day once." |
*
* @param {Notification_Preference_Weekdays_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const notification_preference_weekdays_invalid = /** @type {((inputs?: Notification_Preference_Weekdays_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Preference_Weekdays_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_notification_preference_weekdays_invalid(inputs)
	if (locale === "es-419") return es_419_notification_preference_weekdays_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_notification_preference_weekdays_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_notification_preference_weekdays_invalid(inputs)
	if (locale === "de-DE") return de_de2_notification_preference_weekdays_invalid(inputs)
	if (locale === "it-IT") return it_it2_notification_preference_weekdays_invalid(inputs)
	return en_us2_notification_preference_weekdays_invalid(inputs)
});
export { notification_preference_weekdays_invalid as "notification_preference.weekdays_invalid" }